import { render, staticRenderFns } from "./Radios.vue?vue&type=template&id=6e4b407b&scoped=true&"
import script from "./Radios.vue?vue&type=script&lang=js&"
export * from "./Radios.vue?vue&type=script&lang=js&"
import style0 from "./Radios.vue?vue&type=style&index=0&id=6e4b407b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4b407b",
  null
  
)

export default component.exports